(() => {
  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  onReady(() => {
    const KasuriCart = (window.KasuriCart = window.KasuriCart || {});

    KasuriCart.isDesktop = function () {
      return window.matchMedia && window.matchMedia('(min-width: 1025px)').matches;
    };

    KasuriCart.updateCount = function (count) {
      const n = Math.max(0, Number(count) || 0);
      document.querySelectorAll('.js-header-cart-trigger').forEach((trigger) => {
        const text = trigger.querySelector('.header-cart-text');
        if (text) text.textContent = n > 0 ? `CART (${n})` : 'CART';
        let badge = trigger.querySelector('.header-cart-count');
        const icon = trigger.querySelector('.header-cart-icon');
        if (n > 0) {
          if (!badge && icon) {
            badge = document.createElement('span');
            badge.className = 'nav_cart-count header-cart-count';
            icon.appendChild(badge);
          }
          if (badge) badge.textContent = String(n);
        } else if (badge) {
          badge.remove();
        }
      });
    };

    KasuriCart.markWelcomePending = function () {
      try {
        localStorage.setItem('kasuriWelcomePending', '1');
      } catch (e) {}
    };

    KasuriCart.applyWelcome = async function () {
      const code = String(document.body.getAttribute('data-welcome-code') || '').trim();
      if (!code) return false;
      let pending = false;
      try {
        pending = localStorage.getItem('kasuriWelcomePending') === '1';
      } catch (e) {}
      const fromCustomer = document.body.getAttribute('data-apply-welcome') === 'true';
      if (!pending && !fromCustomer) return false;
      try {
        if (sessionStorage.getItem('kasuriWelcomeApplied') === code) return false;
      } catch (e) {}

      try {
        const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (!cartRes.ok) return false;
        const cart = await cartRes.json();
        const codes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
        const already = codes.some((entry) => String(entry.code || '').toLowerCase() === code.toLowerCase());
        if (already) {
          try {
            sessionStorage.setItem('kasuriWelcomeApplied', code);
            localStorage.removeItem('kasuriWelcomePending');
          } catch (e) {}
          return false;
        }

        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: code })
        });
        const updated = await res.json();
        const nextCodes = Array.isArray(updated.discount_codes) ? updated.discount_codes : [];
        const ok = nextCodes.some(
          (entry) => String(entry.code || '').toLowerCase() === code.toLowerCase() && entry.applicable !== false
        );
        try {
          sessionStorage.setItem('kasuriWelcomeApplied', code);
          localStorage.removeItem('kasuriWelcomePending');
        } catch (e) {}
        if (ok && document.body.classList.contains('template-cart')) {
          window.location.reload();
        } else if (ok && typeof KasuriCart.refreshDrawer === 'function') {
          KasuriCart.refreshDrawer();
        }
        return ok;
      } catch (e) {
        return false;
      }
    };

    KasuriCart.applyWelcome();

    function getDropdowns() {
      return Array.from(document.querySelectorAll('.w-dropdown'));
    }
    const parts = new WeakMap();
    const portaledLists = new WeakMap(); // dd -> list

    function isFooterDropdown(dd) {
      return !!dd && !!dd.closest && !!dd.closest('footer.footer');
    }

    function getParts(dd) {
      if (parts.has(dd)) return parts.get(dd);
      const toggle = dd.querySelector('.w-dropdown-toggle');
      const list = dd.querySelector('.w-dropdown-list');
      const value = { toggle, list };
      parts.set(dd, value);
      return value;
    }

    function isOpen(dd) {
      const { list } = getParts(dd);
      return !!list && list.classList.contains('w--open');
    }

    function open(dd) {
      const { toggle, list } = getParts(dd);
      if (!toggle || !list) return;
      dd.classList.add('w--open');
      toggle.classList.add('w--open');
      list.classList.add('w--open');
      toggle.setAttribute('aria-expanded', 'true');

      // Mobile menu: lock scroll when the native <details> hamburger is open.
      if (dd.classList && dd.classList.contains('kasuri-menu-drawer')) {
        document.documentElement.classList.add('kasuri-menu-open');
        document.body.classList.add('kasuri-menu-open');
      }
    }

    function close(dd) {
      const { toggle, list } = getParts(dd);
      if (!toggle || !list) return;
      dd.classList.remove('w--open');
      toggle.classList.remove('w--open');
      list.classList.remove('w--open');
      toggle.setAttribute('aria-expanded', 'false');

      if (dd.classList && dd.classList.contains('kasuri-menu-drawer')) {
        document.documentElement.classList.remove('kasuri-menu-open');
        document.body.classList.remove('kasuri-menu-open');
      }

      // Also close any nested dropdowns when a parent closes (mobile menu contains nested dropdowns).
      const nested = Array.from(dd.querySelectorAll('.w-dropdown.w--open'));
      nested.forEach((child) => {
        if (child === dd) return;
        const parts = getParts(child);
        if (!parts.toggle || !parts.list) return;
        child.classList.remove('w--open');
        parts.toggle.classList.remove('w--open');
        parts.list.classList.remove('w--open');
        parts.toggle.setAttribute('aria-expanded', 'false');
      });
    }

    function closeAll(except, opts = {}) {
      const { includeFooter = true } = opts;
      getDropdowns().forEach((dd) => {
        if (!includeFooter && isFooterDropdown(dd)) return;
        if (!except) {
          // Native <details> dropdowns need `open=false` to close reliably.
          if (dd && dd.tagName === 'DETAILS') dd.open = false;
          return close(dd);
        }
        // Don't close the dropdown we're interacting with, or any of its ancestors/descendants.
        if (dd === except) return;
        const { list } = getParts(dd);
        // If the dropdown list is portaled to <body>, dd.contains(except) will be false. Treat the list as part of dd.
        if (dd.contains(except) || except.contains(dd) || (list && list.contains && list.contains(except))) return;
        if (dd && dd.tagName === 'DETAILS') dd.open = false;
        close(dd);
      });
    }

    function closeFooterSiblings(except) {
      getDropdowns().forEach((dd) => {
        if (!isFooterDropdown(dd)) return;
        if (!except) return close(dd);
        if (dd === except) return;
        if (dd.contains(except) || except.contains(dd)) return;
        close(dd);
      });
    }

    function bindDropdown(dd) {
      if (!dd || dd.nodeType !== 1) return;
      if (dd.dataset && dd.dataset.kasuriDropdownBound === '1') return;

      const { toggle, list } = getParts(dd);
      if (!toggle || !list) return;

      // Mark the dropdown as bound so we don't attach duplicate listeners if Shopify re-renders sections.
      if (dd.dataset) dd.dataset.kasuriDropdownBound = '1';

      // Basic a11y
      toggle.setAttribute('aria-haspopup', 'menu');
      toggle.setAttribute('aria-expanded', isOpen(dd) ? 'true' : 'false');

      const isNativeDetails = dd.tagName === 'DETAILS' || dd.classList.contains('kasuri-menu-drawer');

      if (isNativeDetails) {
        // Portal the mobile hamburger panel to <body> so it can't be clipped by header containers/stacking contexts.
        // Keep the same DOM node/classes; we only move it and position it.
        (function ensurePortaled() {
          if (portaledLists.has(dd)) return;
          // Only portal the top-level mobile hamburger panel (marked in Liquid).
          if (!list.hasAttribute('data-kasuri-mobile-menu-panel')) return;

          const placeholder = document.createComment('Kasuri mobile menu panel placeholder');
          dd.insertBefore(placeholder, list);
          document.body.appendChild(list);
          portaledLists.set(dd, list);
          // Keep a reference for debugging and future containment checks.
          list.dataset.kasuriPortaled = '1';
        })();

        function positionPortaledPanel() {
          const panel = portaledLists.get(dd) || list;
          if (!panel) return;
          const header = dd.closest('.global-nav') || document.querySelector('.global-nav');
          const headerRect = header ? header.getBoundingClientRect() : null;
          const top = headerRect ? Math.round(headerRect.bottom) : 96; // fallback ~6rem
          panel.style.top = `${top}px`;
          panel.style.left = '0px';
          panel.style.right = '0px';
          panel.style.bottom = '0px';
        }

        // Native <details>/<summary>: let the browser toggle `open`, then sync Webflow classes.
        // Important: don't preventDefault on the <summary> click or iOS Safari won't open it.
        toggle.addEventListener('click', (e) => {
          // Prevent the global document click handler from immediately closing the menu.
          // (Do NOT preventDefault here, or <details> won't toggle on iOS Safari.)
          e.stopPropagation();
        });

        dd.addEventListener('toggle', (e) => {
          // Only handle the toggle for this details (not nested details, if any).
          if (e && e.target && e.target !== dd) return;
          const next = !!dd.open;
          if (next) {
            closeAll(dd);
            positionPortaledPanel();
            open(dd);
          } else {
            close(dd);
          }
        });

        window.addEventListener('resize', () => {
          if (dd.open) positionPortaledPanel();
        });
      } else {
        // Click toggles (legacy Webflow dropdowns)
        toggle.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const next = !isOpen(dd);
          // Footer: opening one menu should close the others.
          // Non-footer dropdowns: keep the existing "close siblings" behavior.
          if (isFooterDropdown(dd)) {
            if (next) closeFooterSiblings(dd);
          } else {
            closeAll(dd);
          }
          if (next) open(dd);
          else close(dd);
        });
      }

      // Clicking inside an open dropdown panel shouldn't trigger the document-level "outside click" closer.
      // (Links will still navigate normally; we just avoid closing on incidental clicks inside the panel.)
      list.addEventListener('click', (e) => e.stopPropagation());

      // Optional hover open (Webflow uses data-hover)
      const hover = String(dd.getAttribute('data-hover')).toLowerCase() === 'true';
      if (hover) {
        const isHeaderMega = dd.classList.contains('header-shop-dropdown');

        if (isHeaderMega) {
          // The header mega dropdown uses a fixed-position list. Some browsers treat the hover
          // transition between toggle and list as leaving the dropdown, so we debounce close and
          // also listen on the list/toggle directly to keep it open while moving into the panel.
          let over = false;
          let closeTimer = null;

          const clearClose = () => {
            if (closeTimer) window.clearTimeout(closeTimer);
            closeTimer = null;
          };

          const scheduleClose = () => {
            clearClose();
            closeTimer = window.setTimeout(() => {
              if (!over) close(dd);
            }, 160);
          };

          const setOver = (val) => {
            over = val;
            if (over) clearClose();
            else scheduleClose();
          };

          const onEnter = () => {
            setOver(true);
            closeAll(dd);
            open(dd);
          };

          dd.addEventListener('mouseenter', onEnter);
          dd.addEventListener('mouseleave', () => setOver(false));
          toggle.addEventListener('mouseenter', () => setOver(true));
          toggle.addEventListener('mouseleave', () => setOver(false));
          list.addEventListener('mouseenter', () => setOver(true));
          list.addEventListener('mouseleave', () => setOver(false));

          // Keyboard users: keep open while focused inside, close when focus leaves the dropdown.
          dd.addEventListener('focusin', onEnter);
          dd.addEventListener('focusout', () => {
            window.setTimeout(() => {
              if (!dd.contains(document.activeElement)) close(dd);
            }, 0);
          });
        } else {
          dd.addEventListener('mouseenter', () => {
            closeAll(dd);
            open(dd);
          });
          dd.addEventListener('mouseleave', () => close(dd));
        }
      }
    }

    function initDropdowns(scope = document) {
      const root = scope && scope.querySelectorAll ? scope : document;
      Array.from(root.querySelectorAll('.w-dropdown')).forEach(bindDropdown);
    }

    // Initial bind
    initDropdowns(document);

    // Clicking outside should close nav/header dropdowns, but keep footer menus as-is.
    document.addEventListener('click', () => closeAll(undefined, { includeFooter: false }));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAll();
    });

    // Footer: default-open behavior (optional mobile default open)
    (function initFooterDropdowns() {
      const footer = document.querySelector('footer.footer');
      if (!footer) return;

      const footerDropdowns = getDropdowns().filter((dd) => isFooterDropdown(dd));
      if (footerDropdowns.length === 0) return;

      const defaultOpenMobile = String(footer.getAttribute('data-footer-mobile-default-open')).toLowerCase() === 'true';
      const mq = window.matchMedia ? window.matchMedia('(max-width: 1024px)') : null;

      function sync() {
        const isMobile = mq ? mq.matches : false;
        footerDropdowns.forEach((dd) => {
          if (isMobile && defaultOpenMobile) {
            open(dd);
          } else {
            close(dd);
          }
        });
      }

      sync();
      if (mq && mq.addEventListener) mq.addEventListener('change', sync);
      else if (mq && mq.addListener) mq.addListener(sync);
    })();

    // Shopify theme editor: when sections re-render, re-bind dropdown click handlers inside them.
    document.addEventListener('shopify:section:load', (e) => initDropdowns(e && e.target ? e.target : document));
    document.addEventListener('shopify:section:select', (e) => initDropdowns(e && e.target ? e.target : document));

    // Global search overlay + live background results (search template)
    (function initHeaderSearch() {
      const overlay = document.querySelector('#KasuriSearchOverlay');
      if (!overlay) return;

      const form = overlay.querySelector('.kasuri-search-overlay__form');
      const input = overlay.querySelector('.kasuri-search-overlay__input');
      if (!form || !input) return;

      const triggers = Array.from(document.querySelectorAll('a.js-header-search-trigger, a.mobile-search-link')).filter(
        Boolean
      );

      function getSearchUrl() {
        return String(form.getAttribute('action') || '/search').trim();
      }

      function openOverlay(opts = {}) {
        const { focus = true, select = false } = opts;
        overlay.hidden = false;
        overlay.setAttribute('aria-hidden', 'false');
        document.body.classList.add('is-kasuri-search-open');
        if (focus) {
          requestAnimationFrame(() => {
            input.focus();
            if (select) input.select();
          });
        }
      }

      function closeOverlay() {
        overlay.hidden = true;
        overlay.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('is-kasuri-search-open');
      }

      // Click on the translucent backdrop closes (but clicks inside the form do not)
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) closeOverlay();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeOverlay();
      });

      triggers.forEach((a) => {
        a.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          closeAll();

          const isSearchTemplate = document.body.classList.contains('template-search');
          if (isSearchTemplate) {
            openOverlay({ focus: true, select: true });
            return;
          }

          const url = new URL(getSearchUrl(), window.location.origin);
          url.searchParams.set('kasuri_search', '1');
          window.location.assign(url.toString());
        });
      });

      const params = new URLSearchParams(window.location.search);
      const isSearchTemplate = document.body.classList.contains('template-search');
      const shouldOpenOnLoad = isSearchTemplate && params.get('kasuri_search') === '1';

      // Keep the overlay input synced to the current URL query (if present)
      const urlQ = params.get('q');
      if (typeof urlQ === 'string' && urlQ.length >= 0) {
        input.value = urlQ;
      }

      if (shouldOpenOnLoad) {
        openOverlay({ focus: true, select: !urlQ });
      } else {
        closeOverlay();
      }

      // Live background updates on /search as the user types
      if (!isSearchTemplate) return;

      function buildSearchUrl(q, extra = {}) {
        const url = new URL(getSearchUrl(), window.location.origin);
        if (q && String(q).trim()) url.searchParams.set('q', String(q).trim());
        else url.searchParams.delete('q');
        url.searchParams.set('options[prefix]', 'last');
        url.searchParams.set('kasuri_search', '1');
        Object.entries(extra).forEach(([k, v]) => url.searchParams.set(k, v));
        return url;
      }

      function replaceUrl(q) {
        const url = buildSearchUrl(q);
        window.history.replaceState(null, '', url.toString());
      }

      let debounceId = null;
      let aborter = null;

      async function fetchAndSwap(q) {
        const current = document.querySelector('[data-kasuri-search-results]');
        if (!current) return;

        if (aborter) aborter.abort();
        aborter = new AbortController();

        const url = buildSearchUrl(q, { sections: 'main-search' });
        try {
          const res = await fetch(url.toString(), {
            signal: aborter.signal,
            headers: { Accept: 'application/json' },
          });
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          const data = await res.json();
          const html = data && data['main-search'] ? String(data['main-search']) : '';
          if (!html) return;

          const doc = new DOMParser().parseFromString(html, 'text/html');
          const next = doc.querySelector('[data-kasuri-search-results]');
          const cur = document.querySelector('[data-kasuri-search-results]');
          if (next && cur) cur.replaceWith(next);
        } catch (err) {
          if (err && err.name === 'AbortError') return;
          // Silent fail: the normal /search navigation still works
        }
      }

      function onInput() {
        const q = input.value.trim();
        replaceUrl(q);

        if (debounceId) window.clearTimeout(debounceId);
        debounceId = window.setTimeout(() => fetchAndSwap(q), 180);
      }

      input.addEventListener('input', onInput);
    })();

    // Desktop cart drawer (pinned to the bottom of the header/menu)
    (function initHeaderCartDrawer() {
      const trigger = document.querySelector('.js-header-cart-trigger');
      const drawer = document.querySelector('#HeaderCartDrawer');
      if (!trigger || !drawer) return;

      const itemsEl = drawer.querySelector('.header-cart-drawer__items');
      const emptyEl = drawer.querySelector('.header-cart-drawer__empty');
      const subtotalEl = drawer.querySelector('[data-cart-subtotal]');
      const discountsEl = drawer.querySelector('[data-cart-discounts]');
      const totalEl = drawer.querySelector('[data-cart-total]');
      const shippingEl = drawer.querySelector('[data-cart-shipping]');
      const walletsEl = drawer.querySelector('.header-cart-drawer__wallets');
      const closeBtn = drawer.querySelector('.header-cart-drawer__close');

      if (!itemsEl || !emptyEl || !subtotalEl || !discountsEl || !totalEl || !closeBtn) return;

      // Portal onto `.global-nav` so the drawer can pin to the bottom of the menu
      // (same containing block as the SHOP dropdown: top: 100%).
      const drawerHome = drawer.parentNode;
      const drawerPlaceholder = document.createComment('HeaderCartDrawer portal placeholder');
      const nav = document.querySelector('.global-nav');
      if (drawerHome) {
        drawerHome.insertBefore(drawerPlaceholder, drawer);
        (nav || document.body).appendChild(drawer);
      }

      const cartJsonUrl = String(trigger.getAttribute('data-cart-json-url') || '/cart.js').trim();
      const currency = String(trigger.getAttribute('data-currency') || '').trim();
      let finalSaleHandles = [];
      try {
        const raw = trigger.getAttribute('data-final-sale-handles');
        if (raw) finalSaleHandles = JSON.parse(raw);
        if (!Array.isArray(finalSaleHandles)) finalSaleHandles = [];
      } catch (e) {}
      const finalSaleNote = String(trigger.getAttribute('data-final-sale-note') || '').trim();

      function isDesktop() {
        return window.matchMedia && window.matchMedia('(min-width: 1025px)').matches;
      }

      function escapeHtml(str) {
        return String(str || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');
      }

      function formatMoney(cents) {
        const n = typeof cents === 'number' ? cents : Number(cents || 0);
        const amount = (Number.isFinite(n) ? n : 0) / 100;
        const cur = currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
        try {
          return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(amount);
        } catch (e) {
          return `$${amount.toFixed(2)}`;
        }
      }

      const COLOR_TOKENS = [
        'black', 'white', 'grey', 'gray', 'navy', 'silver', 'gold', 'red', 'blue',
        'green', 'brown', 'beige', 'pink', 'purple', 'yellow', 'orange', 'ivory',
        'cream', 'khaki', 'olive', 'bronze', 'brass', 'platinum', 'burgundy', 'multi',
        'print', 'granit', 'stone', 'shore', 'ecru', 'caviar'
      ];
      const SIZE_CODES = ['os', 'osfm', 'osfw', 'osfl', 'onesize', 'xs', 's', 'm', 'l', 'xl', 'xxl', '2xl', '3xl'];

      function looksLikeColor(val) {
        const s = String(val || '').toLowerCase();
        return COLOR_TOKENS.some((tok) => s.indexOf(tok) !== -1);
      }

      function looksLikeSize(val) {
        const raw = String(val || '').trim();
        if (/^\d+(\.\d+)?$/.test(raw)) return true;
        const compact = raw.toLowerCase().replace(/[\s/]/g, '');
        return SIZE_CODES.indexOf(compact) !== -1;
      }

      function formatOptionRows(item) {
        const opts = Array.isArray(item.options_with_values) ? item.options_with_values : [];
        if (!opts.length) {
          const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
          return variant ? `<div class="small-text collection">${escapeHtml(variant)}</div>` : '';
        }
        const sizeOpt = opts.find((o) => String(o.name || '').toLowerCase() === 'size');
        const colorOpt = opts.find((o) => {
          const n = String(o.name || '').toLowerCase();
          return n === 'color' || n === 'colour';
        });
        const inverted = sizeOpt && colorOpt && looksLikeColor(sizeOpt.value) && looksLikeSize(colorOpt.value);
        const rows = [];
        if (inverted) {
          rows.push(['Color', sizeOpt.value], ['Size', colorOpt.value]);
          opts.forEach((o) => {
            const n = String(o.name || '').toLowerCase();
            if (n === 'size' || n === 'color' || n === 'colour' || n === 'title') return;
            if (o.value === 'Default Title') return;
            rows.push([o.name, o.value]);
          });
        } else {
          opts.forEach((o) => {
            if (String(o.name || '').toLowerCase() === 'title' && o.value === 'Default Title') return;
            rows.push([o.name, o.value]);
          });
        }
        return rows
          .map(([name, value]) => `
            <div class="flex" cart-item="options">
              <div class="small-text collection">${escapeHtml(name)}</div>
              <div class="small-text collection">:</div>
              <div class="small-text collection">${escapeHtml(value)}</div>
            </div>
          `)
          .join('');
      }

      function renderShipping(cart) {
        if (!shippingEl) return;
        const thresholdUsd = Number(trigger.getAttribute('data-free-shipping-threshold') || 150);
        const thresholdCents = Math.round((Number.isFinite(thresholdUsd) ? thresholdUsd : 150) * 100);
        const items = Array.isArray(cart.items) ? cart.items : [];
        if (!thresholdCents || items.length === 0) {
          shippingEl.hidden = true;
          shippingEl.textContent = '';
          return;
        }
        const remaining = thresholdCents - (typeof cart.total_price === 'number' ? cart.total_price : 0);
        shippingEl.hidden = false;
        shippingEl.textContent =
          remaining > 0
            ? `${formatMoney(remaining)} away from free Economy shipping`
            : 'Free Economy shipping on this order';
      }

      function renderCartDiscounts(cart) {
        const apps = Array.isArray(cart.cart_level_discount_applications)
          ? cart.cart_level_discount_applications
          : [];
        if (!apps.length) {
          discountsEl.innerHTML = '';
          discountsEl.hidden = true;
          return;
        }
        discountsEl.hidden = false;
        discountsEl.innerHTML = apps
          .map((discount) => {
            const title = escapeHtml(discount.title || 'Discount');
            const amount = formatMoney(discount.total_allocated_amount);
            return `
              <div class="cart_total-wrapper cart_discount-row">
                <div class="cart_discount-copy">
                  <span class="cart_discount-kicker">Discount</span>
                  <span class="cart_discount-name">${title}</span>
                </div>
                <div class="cart_total-quantity cart_discount-amount">-${amount}</div>
              </div>
            `;
          })
          .join('');
      }

      function positionDrawer() {
        const padding = 16;
        const preferredWidth = 560; // ~35rem at 16px base
        const width = Math.min(preferredWidth, window.innerWidth - padding * 2);

        // Pin to the bottom of the header/menu, not the CART text (which sits
        // mid-header and made the drawer appear against the top of the page).
        drawer.style.position = 'absolute';
        drawer.style.top = '100%';
        drawer.style.right = '0px';
        drawer.style.left = 'auto';
        drawer.style.bottom = 'auto';
        drawer.style.width = `${Math.round(width)}px`;
        drawer.style.maxHeight = `calc(100vh - var(--header-shop-panel-top, 9.5rem) - ${padding}px)`;
        drawer.style.overflow = 'hidden';
      }

      function openDrawer() {
        if (!isDesktop()) return;
        positionDrawer();

        drawer.hidden = false;
        drawer.classList.add('w--open');
        drawer.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');

        // Close other dropdowns/drawers to avoid overlap.
        closeAll();

        fetchAndRender();
      }

      function closeDrawer() {
        drawer.hidden = true;
        drawer.classList.remove('w--open');
        drawer.setAttribute('aria-hidden', 'true');
        trigger.setAttribute('aria-expanded', 'false');
      }

      function toggleDrawer() {
        if (drawer.hidden) openDrawer();
        else closeDrawer();
      }

      KasuriCart.openDrawer = openDrawer;
      KasuriCart.refreshDrawer = fetchAndRender;
      KasuriCart.closeDrawer = closeDrawer;

      document.addEventListener('kasuri:cart:open', () => {
        if (KasuriCart.isDesktop()) openDrawer();
      });
      document.addEventListener('kasuri:cart:refresh', fetchAndRender);

      async function fetchAndRender() {
        itemsEl.innerHTML = '';
        emptyEl.hidden = true;
        subtotalEl.textContent = '…';
        totalEl.textContent = '…';
        discountsEl.innerHTML = '';
        discountsEl.hidden = true;

        try {
          const res = await fetch(cartJsonUrl, { headers: { Accept: 'application/json' } });
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          const cart = await res.json();

          const items = Array.isArray(cart.items) ? cart.items : [];
          const subtotal = typeof cart.items_subtotal_price === 'number' ? cart.items_subtotal_price : 0;
          const total = typeof cart.total_price === 'number' ? cart.total_price : subtotal;
          subtotalEl.textContent = formatMoney(subtotal);
          totalEl.textContent = formatMoney(total);
          renderCartDiscounts(cart);
          renderShipping(cart);
          if (walletsEl) walletsEl.hidden = items.length === 0;
          const trustEl = drawer.querySelector('.cart_trust-note');
          if (trustEl) trustEl.hidden = items.length === 0;
          KasuriCart.updateCount(typeof cart.item_count === 'number' ? cart.item_count : items.length);

          if (items.length === 0) {
            emptyEl.hidden = false;
            itemsEl.innerHTML = '';
            return;
          }

          itemsEl.innerHTML = items
            .map((item) => {
              const title = item.product_title || item.title || '';
              const url = item.url || '#';
              const img = item.image || item.featured_image?.url || '';
              const optionsHtml = formatOptionRows(item);
              const qty = item.quantity || 0;
              const unit = formatMoney(item.price);
              const line = formatMoney(item.line_price);
              const handle = item.handle || '';
              const isFinalSale = finalSaleNote && finalSaleHandles.indexOf(handle) !== -1;
              const finalSaleHtml = isFinalSale ? `<div class="cart-item-final-sale-note small-text collection">${escapeHtml(finalSaleNote)}</div>` : '';

              return `
                <div class="cart-item-wrapper">
                  <a class="cart_img-wrapper" href="${escapeHtml(url)}" aria-label="${escapeHtml(title)}">
                    ${img ? `<img class="cart-item-image" src="${escapeHtml(img)}" alt="${escapeHtml(title)}" loading="lazy">` : ''}
                  </a>
                  <div class="cart-item-data mini-cart">
                    <div class="cart-item-title">${escapeHtml(title)}</div>
                    ${optionsHtml}
                    <div class="flex space-between _w-100">
                      <div class="quantity-wrap">
                        <div class="qty-subtotal-wrap">
                          <div class="small-text collection">${qty}</div>
                          <div class="x">x</div>
                          <div class="small-text collection">${unit}</div>
                        </div>
                      </div>
                      <div class="small-text collection">${line}</div>
                    </div>
                    ${finalSaleHtml}
                  </div>
                </div>
              `;
            })
            .join('');
        } catch (err) {
          subtotalEl.textContent = '';
          totalEl.textContent = '';
          discountsEl.innerHTML = '';
          discountsEl.hidden = true;
          if (shippingEl) {
            shippingEl.hidden = true;
            shippingEl.textContent = '';
          }
          if (walletsEl) walletsEl.hidden = true;
          emptyEl.hidden = false;
          emptyEl.textContent = 'Unable to load cart. Please try again.';
        }
      }

      // Trigger click: open drawer on desktop, otherwise fall back to normal /cart navigation.
      trigger.addEventListener('click', (e) => {
        if (!isDesktop()) return;
        e.preventDefault();
        e.stopPropagation();
        toggleDrawer();
      });

      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeDrawer();
      });

      // Clicking inside the drawer shouldn't close it.
      drawer.addEventListener('click', (e) => e.stopPropagation());

      // Outside click closes
      document.addEventListener('click', () => closeDrawer());

      // ESC closes (search/dropdowns also listen globally)
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeDrawer();
      });

      window.addEventListener('resize', () => {
        if (!drawer.hidden) positionDrawer();
      });

      // If we cross into non-desktop, ensure the drawer is closed so navigation works as expected.
      window.addEventListener('resize', () => {
        if (!isDesktop()) closeDrawer();
      });

      // Start closed
      closeDrawer();
    })();
  });
})();


